interface Props {
  fill?: string;
  stroke?: string;
  width?: string;
  height?: string;
  className?: string;
}

const Transaction = ({
  fill = '#231f20',
  stroke = '#231f20',
  height = '11.425984mm',
  width = '12.106665mm',
  className,
}: Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 12.106665 11.425984"
    className={className}
  >
    <g transform="translate(-90.708573,-128.84652)" id="layer1">
      <path
        d="m 101.14212,140.00931 c -0.004,-0.0713 0.0194,-0.14394 0.0706,-0.20144 l 0.92921,-1.0414 -1.04175,-0.92957 c -0.11501,-0.10266 -0.12524,-0.27905 -0.0226,-0.39405 0.10266,-0.11465 0.27905,-0.12524 0.39405,-0.0226 l 1.2506,1.11513 c 0.0547,0.0494 0.0882,0.11854 0.0924,0.19262 0.004,0.0737 -0.0208,0.1464 -0.0706,0.20143 l -1.11513,1.2499 c -0.10266,0.115 -0.2787,0.12488 -0.3937,0.0222 -0.0575,-0.0512 -0.0889,-0.12065 -0.0931,-0.19227"
        style={{
          fill,
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
          strokeWidth: 0.352777,
        }}
        id="path366"
      />
      <path
        d="m 97.197991,134.2506 c -0.257175,-0.12488 -0.510822,-0.18732 -0.510822,-0.39229 0,-0.1838 0.107244,-0.23883 0.278694,-0.23883 0.121003,0 0.226131,0.0452 0.323498,0.12136 0.07373,0.0624 0.15875,0.10371 0.261055,0.10371 0.191206,0 0.3302,-0.17991 0.3302,-0.35101 0,-0.12876 -0.06668,-0.23883 -0.187678,-0.32385 -0.103716,-0.0787 -0.218722,-0.13864 -0.337608,-0.17992 v -0.16369 c 0,-0.15839 -0.128411,-0.28716 -0.287161,-0.28716 h -0.208492 c -0.159103,0 -0.287514,0.12877 -0.287514,0.28716 v 0.18027 c -0.364772,0.15346 -0.587022,0.51329 -0.587022,0.86678 0,0.56233 0.499533,0.80116 0.919339,0.99589 0.333375,0.15346 0.444853,0.24977 0.444853,0.39229 0,0.23883 -0.198967,0.35736 -0.429684,0.35736 -0.132644,0 -0.253647,-0.0148 -0.40005,-0.121 -0.07373,-0.0624 -0.159808,-0.11395 -0.263525,-0.11395 -0.191205,0 -0.329847,0.17992 -0.329847,0.35137 0,0.12488 0.06244,0.22613 0.177447,0.31468 0.127353,0.0974 0.319617,0.18132 0.468489,0.22119 v 0.12488 c 0,0.15875 0.128411,0.28752 0.287514,0.28752 h 0.208492 c 0.15875,0 0.287161,-0.12877 0.287161,-0.28752 v -0.14852 c 0.419806,-0.14146 0.707319,-0.49353 0.707319,-1.00718 -0.0014,-0.5147 -0.358422,-0.7433 -0.864658,-0.98954"
        style={{
          fill,
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
          strokeWidth: 0.352777,
        }}
        id="path908"
      />
      <path
        d="M 91.061351,138.80937 H 101.99746"
        style={{
          stroke,
          strokeWidth: 0.705556,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path986"
      />
      <path
        d="m 92.381693,131.50623 c 0.0039,-0.0713 -0.0194,-0.14428 -0.0702,-0.20143 l -0.92957,-1.0414 1.041753,-0.92957 c 0.115005,-0.10266 0.125236,-0.27905 0.02258,-0.39405 -0.102659,-0.11466 -0.279048,-0.12524 -0.394053,-0.0226 l -1.250597,1.11513 c -0.05468,0.0494 -0.08819,0.11853 -0.09243,0.19262 -0.0042,0.0737 0.02081,0.1464 0.07056,0.20143 l 1.11513,1.24989 c 0.102658,0.11501 0.278695,0.12489 0.3937,0.0222 0.0575,-0.0512 0.0889,-0.12065 0.09313,-0.19227"
        style={{
          fill,
          fillOpacity: 1,
          fillRule: 'nonzero',
          stroke: 'none',
          strokeWidth: 0.352777,
        }}
        id="path990"
      />
      <path
        d="M 102.46246,130.3063 H 91.526348"
        style={{
          stroke,
          strokeWidth: 0.705556,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path994"
      />
      <path
        d="M 91.612777,134.42907 H 93.56011"
        style={{
          stroke,
          strokeWidth: 0.705556,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path998"
      />
      <path
        d="m 100.03313,135.3404 h 1.94733"
        style={{
          stroke,
          strokeWidth: 0.705556,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeMiterlimit: 10,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        id="path1002"
      />
    </g>
  </svg>
);

export default Transaction;
